module.exports = __webpack_public_path__ + "static/media/img2-1.4ef4811f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/biosense/diff/img2-1.png
// module id = 2378
// module chunks = 3